import { render } from "./StartHubOrient.vue?vue&type=template&id=8f998cb8"
import script from "./StartHubOrient.vue?vue&type=script&lang=js"
export * from "./StartHubOrient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__